const DEFAULT_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const formatDateTime = (v, tz) => v ? new Date(v).toLocaleString('en-US', { timeZone: tz || DEFAULT_TZ }) : '--';
export const formatDate = (v, tz) => v ? new Date(v).toLocaleDateString('en-US', { timeZone: tz || DEFAULT_TZ }) : '--';
export const formatTime = (v, tz) => v ? new Date(v).toLocaleTimeString('en-US', { timeZone: tz || DEFAULT_TZ, hour: '2-digit', minute: '2-digit' }) : '--';
export const timeAgo = (ts) => {
  if (!ts) return 'Never';
  const diff = Date.now() - new Date(ts).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'Just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
};
